module.exports = __webpack_public_path__ + "static/6-a19c6b2bab99b5e0e5d5a16a5601d83b.jpg";